export default __webpack_public_path__ + "static/media/bsale.fa1cd1bb.png";